// Core fields that can exist across all entity types
// Metastructure determines which ones are active for each entity
export const CORE_FIELD_NAMES = {
  // Production fields
  STATUS: 'status',
  PRODUCTION_DATE: 'production_date',
  CODE: 'code',
  ARCHIVED: 'archived',
  USER_ID: 'userId',
  PRODUCTION_TYPE_ID: 'productionTypeId',
  ICON: 'icon',
  COLOR: 'color',
  TITLE: 'title',
  DESCRIPTION: 'description',
  BUDGET_AMOUNT: 'budget_amount',

  // Resource fields
  RESOURCE_TYPE_ID: 'resource_type_id',
  ORGANISATION_ID: 'organisation_id',
  REPRESENTED_BY_ID: 'represented_by_id',
  ROLE: 'role',
  TAGS: 'tags',
  GROUPS: 'groups',
  EMAILS: 'emails',
  PHONES: 'phone_numbers',
  WEBSITES: 'websites',
  SOCIALS: 'socials',
  LOCATIONS: 'locations',

  // Common fields
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt'
} as const;

export type CoreFieldName =
  (typeof CORE_FIELD_NAMES)[keyof typeof CORE_FIELD_NAMES];
